<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <v-dialog
        v-model="dialogStartPromotionsPoint"
        style="border-radius: 0px !important"
        width="300"
      >
        <!-- <v-btn fab><v-icon>mdi-close</v-icon></v-btn> -->
        <v-date-picker
          v-model="formUpdate.startMultiplyPoint"
          style="border-radius: 0px !important"
          color="rgb(28 67 124)"
          locale="th-th"
          @change="dialogStartPromotionsPoint = false"
        ></v-date-picker>
      </v-dialog>
      <v-dialog
        v-model="dialogEndPromotionsPoint"
        style="border-radius: 0px !important"
        width="300"
      >
        <!-- <v-btn fab><v-icon>mdi-close</v-icon></v-btn> -->
        <v-date-picker
          v-model="formUpdate.endMultiplyPoint"
          style="border-radius: 0px !important"
          color="rgb(28 67 124)"
          locale="th-th"
          @change="dialogEndPromotionsPoint = false"
        ></v-date-picker>
      </v-dialog>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn v-if="tab===0"
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
            <v-btn v-if="tab===1"
              color="#1B437C"
              depressed
              v-show="btnAdd"
              dark
              @click=";(dialogAddDiscount = true), validate('ADD')"
            >
              <v-icon
                left
              >mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearDataAdd()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-row class="mb-6" justify="center" style="display: grid;">
                      <v-col md="auto">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/Object.png')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row class="mb-6" justify="center" style="display: grid;">
                      <v-col md="auto">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row> -->
                    <v-row>
                      <v-col style="padding: 15px 16px 0px; text-align: left;">
                        <h2>เพิ่มอัตราการแลกเปลี่ยนคะแนน</h2>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formAdd.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formAdd.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <VuetifyMoney
                          v-model="formAdd.exchangeRate"
                          label="ยอดใช้จ่ายต่อ 1 คะแนน"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                      <v-col cols="12" v-if="haveBelink">
                        <v-select
                          v-model="formAdd.flowId"
                          :items="itemLinked"
                          label="ประเภทบริการ"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                    <!-- <v-row style="height: 75px" v-if="items.length > 0">
                      <v-col cols="12">
                        <v-combobox
                          v-show="items.length > 0"
                          v-model="value"
                          :items="items"
                          label="ร้านค้า"
                          outlined
                          light
                          multiple
                          @change="filterItem(value)"
                        ></v-combobox>
                      </v-col>
                    </v-row> -->
                    <!-- <v-row style="height: 65px">
                      {{formAdd.status}}
                      <v-checkbox
                        v-model="formAdd.status"
                        label="แสดงข้อมูล"
                        class="mx-auto"
                      ></v-checkbox>
                    </v-row> -->
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col>
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      style="color: white !important;"
                      @click="addData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- ADD CHANGE TO DISCOUNT -->
          <v-dialog v-model="dialogAddDiscount" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAddDiscount = false), clearDataAddDiscount()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-row class="mb-6" justify="center" style="display: grid;">
                      <v-col md="auto">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/Object.png')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row class="mb-6" justify="center" style="display: grid;">
                      <v-col md="auto">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row> -->
                    <v-row>
                      <v-col style="padding: 15px 16px 0px; text-align: left;">
                        <h2>เพิ่มอัตราการแลกเปลี่ยนส่วนลด</h2>
                      </v-col>
                    </v-row>
                    <v-img
                      aspect-ratio="6"
                      contain
                      :src="pictureUrlPreview"
                      v-if="pictureUrlPreview"
                    ></v-img>
                    <br />
                    <v-file-input
                      required
                      counter
                      show-size
                      :rules="[rules.required]"
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Image"
                      @change="selectImg"
                      v-model="filesAdd"
                    ></v-file-input>
                    <!-- <v-col
                      cols="12"
                      style="display: flex; justify-content: center"
                    >
                      <v-card
                        @click="chooseImage"
                        class="image-input"
                        :style="{
                          backgroundImage:
                          'url(' + formAddDiscount.pictureUrlPreview + ')',
                          'background-size': 'contain',
                          'background-position': 'center center',
                          'background-repeat': 'no-repeat'
                        }"
                        >
                        <span
                          v-if="formAddDiscount.pictureUrlPreview === ''"
                          class="placeholder"
                        >
                          Choose an Image
                        </span>
                        <input
                          style="display: none"
                          class="file-input"
                          ref="fileInput"
                          type="file"
                          @input="onSelectFile"
                        />
                      </v-card>
                    </v-col> -->
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formAddDiscount.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formAddDiscount.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <VuetifyMoney
                          v-model="formAddDiscount.exchangeRate"
                          label="จำนวนคะแนนต่อ 1 บาท"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      dark
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addDataDiscount()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearDataUpdate()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img :src="require('@/assets/Object.svg')"></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row> -->
                    <v-row>
                      <v-col style="padding: 15px 16px 0px; text-align: left;">
                        <h2>แก้ไขอัตราการแลกเปลี่ยนคะแนน</h2>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formUpdate.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formUpdate.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <VuetifyMoney
                          v-model="formUpdate.exchangeRate"
                          label="ยอดใช้จ่ายต่อ 1 คะแนน"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                      <v-col cols="6" v-if="haveBelink">
                        <v-select
                          clearable
                          v-model="formUpdate.flowId"
                          :items="itemLinkedAfterFliter"
                          label="ประเภทบริการ"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                    <div style="text-align: left; margin-top: 15px;margin-bottom: 10px">
                      <v-icon>mdi-star-shooting</v-icon> คะแนนโปรโมชั่น
                      <div style="color: red" v-if="alertFilData">กรุณากรอกข้อมูล คะแนนโปรโมชั่นให้ครบ</div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-select
                          v-model="formUpdate.multiplyPoint"
                          :items="itemsMultiply"
                          label="ตัวคูณคะแนน"
                          outlined
                          hide-details
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="formUpdate.startMultiplyPoint"
                          @click="dialogStartPromotionsPoint = true"
                          label="วันที่เริ่มโปรโมชั่น"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="formUpdate.endMultiplyPoint"
                          @click="dialogEndPromotionsPoint = true"
                          label="วันที่สิ้นสุดโปรโมชั่น"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- <v-row style="height: 75px" v-if="items.length > 0">
                      <v-col cols="12">
                        <v-combobox
                          v-show="items.length > 0"
                          v-model="value2"
                          :items="items"
                          label="ร้านค้า"
                          outlined
                          dense
                          multiple
                          @change="filterItem(value)"
                        ></v-combobox>
                      </v-col>
                    </v-row> -->
                    <!-- <v-row style="height: 65px">
                      <v-checkbox
                        v-model="formUpdate.status"
                        label="แสดงข้อมูล"
                        class="mx-auto"
                      ></v-checkbox>
                    </v-row> -->
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      :disabled="!validUpdate"
                      color="#173053"
                      dark
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- edit discount-->
          <v-dialog v-model="dialogEditDiscount" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEditDiscount = false), clearDataUpdateDiscount()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img :src="require('@/assets/Object.svg')"></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row> -->
                    <v-row>
                      <v-col style="padding: 15px 16px 0px; text-align: left;">
                        <h2>แก้ไขอัตราการแลกเปลี่ยนส่วนลด</h2>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <v-text-field
                          v-model="formUpdate.name"
                          label="ชื่อสินค้า/บริการ"
                          outlined
                          dense
                          required
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col>
                        <v-text-field
                          label="รายละเอียด"
                          outlined
                          dense
                          v-model="formUpdate.detail"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="height: 75px">
                      <v-col cols="12">
                        <VuetifyMoney
                          v-model="formUpdate.exchangeRate"
                          label="จำนวนคะแนนต่อ 1 บาท"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-col>
                    </v-row>
                    <!-- <div style="text-align: left; margin-top: 15px;margin-bottom: 10px">
                      <v-icon>mdi-star-shooting</v-icon> คะแนนโปรโมชั่น
                      <div style="color: red" v-if="alertFilData">กรุณากรอกข้อมูล คะแนนโปรโมชั่นให้ครบ</div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-select
                          v-model="formUpdateDiscount.multiplyPoint"
                          :items="itemsMultiply"
                          label="ตัวคูณคะแนน"
                          outlined
                          hide-details
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="formUpdateDiscount.startMultiplyPoint"
                          @click="dialogStartPromotionsPoint = true"
                          label="วันที่เริ่มโปรโมชั่น"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="formUpdateDiscount.endMultiplyPoint"
                          @click="dialogEndPromotionsPoint = true"
                          label="วันที่สิ้นสุดโปรโมชั่น"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row> -->
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      :disabled="!validUpdate"
                      color="#173053"
                      dark
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="30%">
            <v-card>
              <v-card-title class="pa-3">
                <span>ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 75px">
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส ProductExchangeRate*"
                        v-model="formUpdate.productExchangeRateId"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row style="height: 75px">
                    <v-col cols="12">
                      <v-text-field
                        label="สินค้า/บริการ"
                        v-model="formUpdate.name"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card>
              <v-tabs v-model="tab" color="#1b437c">
                <v-tab>
                  <h4>อัตราการแลกเปลี่ยนคะแนน</h4>
                </v-tab>
                <v-tab>
                  <h4>อัตราการแลกเปลี่ยนส่วนลด</h4>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" elevation="7">
                <v-tab-item>
                  <v-card v-if="dataReady">
                    <v-card-title>
                      <!-- <v-text-field
                        v-model="searchAll2"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field> -->
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columns"
                        :items="dataItem.filter(item => item.changePointTodiscount !== 'True')"
                        :search="searchAll2"
                        :items-per-page="10"
                      >
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.LAST_DATE) }}
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="btn-color"
                                fab
                                x-small
                                dark
                                @click.stop="
                                  ;(dialogEdit = true),
                                    getData(item),
                                    validate('UPDATE')
                                "
                              >
                                <v-icon dark> mdi-tools </v-icon>
                              </v-btn>
                            </template>
                            <span>แก้ไขข้อมูล</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="red"
                                dark
                                fab
                                x-small
                                @click.stop="
                                  ;(dialogDelete = true), getDataById(item)
                                "
                              >
                                <v-icon> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>ลบข้อมูล</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <div v-if="!dataReady" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <v-card v-if="dataReady">
                    <v-card-title>
                      <v-text-field
                        v-model="searchAll3"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columns"
                        :items="dataItem.filter(item => item.changePointTodiscount == 'True')"
                        :search="searchAll3"
                        :items-per-page="10"
                      >
                        <template v-slot:[`item.pictureUrl`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.pictureUrl" alt="img"
                          /></v-avatar>
                        </template>
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.LAST_DATE) }}
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="btn-color"
                                fab
                                x-small
                                dark
                                @click.stop="
                                  ;(dialogEditDiscount = true),
                                    getData(item),
                                    validate('UPDATE')
                                "
                              >
                                <v-icon dark> mdi-tools </v-icon>
                              </v-btn>
                            </template>
                            <span>แก้ไขข้อมูล</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="red"
                                dark
                                fab
                                x-small
                                @click.stop="
                                  ;(dialogDelete = true), getDataById(item)
                                "
                              >
                                <v-icon> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>ลบข้อมูล</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <div v-if="!dataReady" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {},
  data () {
    return {
      PK: '',
      path: '/productExchangeRate/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สินค้าและบริการ',
          disabled: false,
          href: '/Master/ProductExchangeRate'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      //   typecoin: ['เหรียญหลัก', 'เหรียญรอง'],
      // End Menu Config
      tab: null,
      btnAdd: true,
      filesAdd: null,
      filesUpdate: null,
      returnLink: '/Master/ProductExchangeRate',
      dataReady: true,
      canvas: true,
      dialogStartPromotionsPoint: false,
      dialogEndPromotionsPoint: false,
      startDatePromotionsPoint: null,
      endDatePromotionsPoint: null,
      multiplyPoint: null,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      searchAll3: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        name: '',
        exchangeRate: 0,
        flowId: '',
        flowName: '',
        detail: '',
        status: 'True',
        CREATE_USER: '',
        LAST_USER: '',
        userId: [],
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        productExchangeRateId: '',
        name: '',
        flowId: '',
        exchangeRate: '',
        detail: '',
        status: 'True',
        userId: '',
        LAST_USER: '',
        shopId: ''
      },
      itemsMultiply: [
        {text: 'คะแนนคูณ 2', value: 2},
        {text: 'คะแนนคูณ 3', value: 3},
        {text: 'คะแนนคูณ 4', value: 4},
        {text: 'คะแนนคูณ 5', value: 5},
        {text: 'คะแนนคูณ 6', value: 6},
        {text: 'คะแนนคูณ 7', value: 7},
        {text: 'คะแนนคูณ 8', value: 8},
        {text: 'คะแนนคูณ 9', value: 9},
        {text: 'คะแนนคูณ 10', value: 10}
      ],
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ID', value: 'productExchangeRateId' },
        { text: 'บริการ', value: 'name' },
        { text: 'อัตราแลกเปลี่ยน', value: 'exchangeRate' },
        { text: 'รายละเอียด', value: 'detail' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      items: [],
      itemLinkedAfterFliter: [],
      value: null,
      alertFilData: false,
      itemLinked: [],
      value2: [],
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAddDiscount: false,
      dialogEditDiscount: false,
      dialogDeleteDiscount: false,
      dialogImportDiscount: false,
      changePointTodiscount: false,
      formAddDiscount: {
        name: '',
        exchangeRate: 0,
        flowId: '',
        flowName: '',
        detail: '',
        status: 'True',
        CREATE_USER: '',
        LAST_USER: '',
        userId: [],
        changePointTodiscount: 'True',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdateDiscount: {
        productExchangeRateId: '',
        name: '',
        flowId: '',
        exchangeRate: '',
        detail: '',
        status: 'True',
        userId: '',
        LAST_USER: '',
        changePointTodiscount: 'True',
        shopId: ''
      },
      pictureUrlPreview: '',
      haveBelink: false,
      datatFlowId: {}
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    await this.checkBelink()
    this.getitem()
    this.getFlowLinked()
    this.checkStatus()
    console.log('aassss', this.dataItem)
  },
  methods: {
    selectStartDate () {

    },
    selectEndtDate () {

    },
    async checkBelink () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IPBelink + '/sys_shop/get?shopId=' + this.$session.getAll().data.shopId
        )
        .then(async response => {
          if (response.data.length > 0) {
            this.haveBelink = true
            // await this.getBranchBelink()
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function checkBelink : ', error)
        })
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    async selectImg (event) {
      if (this.filesAdd) {
        this.pictureUrlPreview = await URL.createObjectURL(
          this.filesAdd
        )
        this.items.push(this.pictureUrlPreview)
      } else {
        this.pictureUrlPreview = ''
      }
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.pictureUrlPreview = ''
      }
    },
    filterItem (value) {
      console.log(value)
      this.formAdd.userId = []
      value.forEach((element, key) => {
        console.log('el', element.displayName)
        this.formAdd.userId.push(element.userId)
      })
    },
    async getitem () {
      await axios
        .get(
          this.DNS_IP +
            '/system_user/get?shopId=' +
            this.session.data.shopId +
            '&userTypeGroup=Operation'
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.value = d.userId
            d.text = d.displayName
            this.items.push(d)
          }
        })
    },
    async checkStatus () {
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/get?shopId=' +
            this.session.data.shopId +
            '&changePointTodiscount=true'
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.btnAdd = !this.btnAdd
          }
        })
    },
    async getFlowLinked () {
      this.itemLinked = []
      this.itemLinkedAfterFliter = []
      await axios
        .get(
          'https://api-belinked.betaskthai.tech/flow/get?shopId=' +
            // 'Ucb91b5fb61ff0c01e6d7d4c5f7962c57'
            this.session.data.shopId
          //     http://localhost:8081/ConditionFlow?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&flowId=45
        )
        .then(response => {
          console.log('rsssss', response.data)
          let rs = response.data
          if (rs.status === false) {
            this.itemLinked = []
          } else {
            rs.forEach(el => {
              this.itemLinked.push({
                value: el.flowId.toString(),
                text: el.flowName
              })
              this.datatFlowId[el.flowId] = el.flowName
            })
            const flowIds = this.dataItem
              .filter(i => i.flowId !== '' && i.flowId !== null)
              .map(i => i.flowId)
            this.itemLinked.map(linkedItem => console.log('flowIds', linkedItem))
            this.itemLinked = this.itemLinked.filter(linkedItem => !flowIds.includes(linkedItem.value))
            // this.itemLinked = this.itemLinked.filter((item) => {
            //   item.value
            // })
          }
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      var search =
        '?productExchangeRateId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      this.dataReady = false
      this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'productExchangeRateId',
        item.productExchangeRateId,
        this.returnLink
      )
    },
    async getData (item) {
      await this.getFlowLinked()
      this.value2 = []
      this.itemLinkedAfterFliter = []
      // const flowIds = this.dataItem
      //   .filter(i => i.flowId !== '' && i.flowId !== null)
      //   .map(i => i.flowId)
      // this.itemLinked.map(linkedItem => console.log('flowIds', linkedItem))
      // this.itemLinked = this.itemLinked.filter(linkedItem => !flowIds.includes(linkedItem.value))
      axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/get?shopId=' +
            this.session.data.shopId +
            '&productExchangeRateId=' +
            item.productExchangeRateId
        )
        .then(response => {
          let rs = response.data[0]
          let a = null
          console.log('data', response.data)
          this.formUpdate.name = rs.name
          this.formUpdate.detail = rs.detail
          this.formUpdate.exchangeRate = rs.exchangeRate
          this.formUpdate.flowId = rs.flowId
          this.formUpdate.status = rs.status
          this.formUpdate.userId = rs.userId
          this.formUpdate.multiplyPoint = rs.multiplyPoint
          this.formUpdate.startMultiplyPoint = rs.startMultiplyPoint
          this.formUpdate.endMultiplyPoint = rs.endMultiplyPoint
          this.value = rs.userId
          console.log('userId', typeof rs.userId)
          // this.value = JSON.parse(rs.displayName)
          this.formUpdate.productExchangeRateId = rs.productExchangeRateId
          this.formUpdate.shopId = rs.shopId
          this.formUpdate.LAST_DATE = rs.LAST_DATE
          this.formUpdate.CREATE_DATE = rs.CREATE_DATE
          if (this.formUpdate.status === 'False') {
            this.formUpdate.status = false
          }
          console.log('ddd', rs.userId)
          if (rs.userId && rs.userId !== '') {
            a = JSON.parse(rs.userId).map(a =>
              this.items.filter(b => a === b.value)
            )
            a.map(a =>
              this.value2.push({ value: a[0].value, text: a[0].displayName })
            )
          }
          console.log('this.itemLinkedAfterFliter 1>>>', this.itemLinkedAfterFliter)
          console.log('this.itemLinked 1>>>', this.itemLinked)
          this.itemLinkedAfterFliter = this.itemLinked.slice()
          if (rs.flowId !== '' && rs.flowId !== null) {
            this.itemLinkedAfterFliter.push({'value': rs.flowId.toString(), 'text': this.datatFlowId[rs.flowId]})
          }
          console.log('this.itemLinkedAfterFliter 2>>>', this.itemLinkedAfterFliter)
          console.log('this.itemLinked 2>>>', this.itemLinked)
          //   if (this.value) {
          //     this.value.map(el => {
          //       this.items.filter(item => {
          //         item.value = el
          //       })
          //     })
          //   }

          // this.multiplyPoint = null
          // this.startDatePromotionsPoint = null
          // this.endDatePromotionsPoint = null
          console.log('dfdfdfd', this.formUpdate)
          // console.log(this.items)
        }).catch(error => console.log(error))
    },
    async addData () {
      this.dataReady = false
      console.log('value', this.value)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          if (this.value !== null) {
            this.formAdd.userId = JSON.stringify(this.value.map(a => a.value))
          } else {
            this.formAdd.userId = ''
          }

          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          JSON.stringify(this.formAdd.userId)
          console.log('add', this.formAdd)
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async response => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.clearDataAdd()
              await this.getFlowLinked()
              this.loadingAdd = false
            })
            .catch(error => {
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async addDataDiscount () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true

          let params = new FormData()
          params.append('file', this.filesAdd)
          let pictureUrl = ''
          await axios
            .post(this.DNS_IP + `/file/upload/reward`, params)
            .then(function (response) {
              pictureUrl = response.data
              console.log('url Pic', response.data)
            })

          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAddDiscount)
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              const body = {
                'PictureURL': pictureUrl,
                'name': 'coupon ส่วนลด',
                'nameEng': 'coupon discount',
                'levelId': 'allLevel',
                'supply': 'coupon',
                'shopId': this.session.data.shopId,
                'CREATE_USER': this.session.data.userName,
                'showReward': 'False'
              }
              console.log('body', body)

              await axios.post(this.DNS_IP + this.path + 'reward-coupon', body)
                .then(response => {
                  console.log('ลง', response.data)
                })
                .catch(error => {
                  console.log('ddddd', error)
                })

              // this.formAddDiscount.pictureUrl = ''
              // this.formAddDiscount.pictureUrlPreview = ''

              // if (this.value !== null) {
              //   this.formAddDiscount.userId = JSON.stringify(this.value.map(a => a.value))
              // } else {
              //   this.formAddDiscount.userId = ''
              // }
              // this.formAddDiscount.CREATE_USER = this.session.data.userName
              // this.formAddDiscount.LAST_USER = this.session.data.userName
              // this.formAddDiscount.shopId = this.session.data.shopId
              // this.formAddDiscount.changePointTodiscount = true
              // JSON.stringify(this.formAddDiscount.userId)
              // console.log('add_dis', this.formAddDiscount)

              this.dialogAddDiscount = false
              await this.clearDataAddDiscount()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.btnAdd = false
              this.loadingAdd = false
            })
            .catch(error => {
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      if (this.formUpdate.startMultiplyPoint || this.formUpdate.endMultiplyPoint || this.formUpdate.multiplyPoint) {
        if (this.formUpdate.startMultiplyPoint && this.formUpdate.endMultiplyPoint && this.formUpdate.multiplyPoint) {
          await this.callEditApi()
        } else {
          this.alertFilData = true
        }
      } else {
        await this.callEditApi()
      }
    },
    async callEditApi () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          // if (this.formUpdate.startMultiplyPoint && this.formUpdate.endMultiplyPoint && this.formUpdate.multiplyPoint) {
          //   this.formUpdate.multiplyPoint = this.multiplyPoint
          //   this.formUpdate.startMultiplyPoint = this.startDatePromotionsPoint
          //   this.formUpdate.endMultiplyPoint = this.endDatePromotionsPoint
          // }
          if (!this.formUpdate.flowId) {
            this.formUpdate.flowId = ''
          }
          this.formUpdate.userId = JSON.stringify(this.value2.map(a => a.value))
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.productExchangeRateId
          delete this.formUpdate['productExchangeRateId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          await axios
            .post(this.DNS_IP + this.path + 'edit/' + ID, this.formUpdate)
            .then(async response => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              this.dialogEditDiscount = false
              this.clearDataUpdate()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
              this.formUpdate.multiplyPoint = null
              this.formUpdate.startMultiplyPoint = null
              this.formUpdate.endMultiplyPoint = null

              this.alertFilData = false
            })
            .catch(error => {
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.productExchangeRateId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      if (this.tab === 1) {
        this.btnAdd = true
      }
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.productExchangeRateId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
      await this.getFlowLinked()
    },
    async clearDataAdd () {
      this.formAdd.name = ''
      this.formAdd.exchangeRate = 0
      this.formAdd.detail = ''
      this.formAdd.status = ''
      this.formAdd.flowId = ''
      this.formAdd.userId = ''
      this.value = null
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    async clearDataAddDiscount () {
      this.formAddDiscount.name = ''
      this.formAddDiscount.exchangeRate = 0
      this.formAddDiscount.detail = ''
      this.formAddDiscount.status = ''
      this.formAddDiscount.flowId = ''
      this.formAddDiscount.userId = ''
      this.value = null
      this.formAddDiscount.CREATE_USER = ''
      this.formAddDiscount.LAST_USER = ''
      this.formAddDiscount.pictureUrl = ''
      this.formAddDiscount.shopId = this.$session.getAll().data.shopId
    },
    async clearDataUpdate () {
      this.formUpdate.productExchangeRateId = ''
      this.formUpdate.name = ''
      this.formUpdate.exchangeRate = 0
      //   this.formUpdate.TypeCoin = ''
      this.value = null
      this.formAdd.userId = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.multiplyPoint = ''
      this.formUpdate.startMultiplyPoint = ''
      this.formUpdate.endMultiplyPoint = ''
      this.alertFilData = false
    },
    async clearDataUpdateDiscount () {
      this.formUpdateDiscount.productExchangeRateId = ''
      this.formUpdateDiscount.name = ''
      this.formUpdateDiscount.exchangeRate = 0
      this.value = null
      this.formAddDiscount.userId = ''
      this.formUpdateDiscount.LAST_USER = ''
      this.formUpdateDiscount.shopId = ''
      this.formUpdateDiscount.multiplyPoint = ''
      this.formUpdateDiscount.startMultiplyPoint = ''
      this.formUpdateDiscount.endMultiplyPoint = ''
      this.alertFilData = false
    }
  }
}
</script>
<style scoped>
.image-input {
  display: block;
  width: 250px;
  height: 250px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/ProductExchangeRate.vue